import AccessTime from '@mui/icons-material/AccessTime';
import AccessTimeOutlined from '@mui/icons-material/AccessTimeOutlined';
import AccountBalanceOutlined from '@mui/icons-material/AccountBalanceOutlined';
import AccountBoxOutlined from '@mui/icons-material/AccountBoxOutlined';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Add from '@mui/icons-material/Add';
import AddBoxOutlined from '@mui/icons-material/AddBoxOutlined';
import AddCommentOutlined from '@mui/icons-material/AddCommentOutlined';
import AddLocation from '@mui/icons-material/AddLocation';
import AddLocationAlt from '@mui/icons-material/AddLocationAlt';
import AddOutlined from '@mui/icons-material/AddOutlined';
import AddRounded from '@mui/icons-material/AddRounded';
import AlternateEmail from '@mui/icons-material/AlternateEmail';
import AltRoute from '@mui/icons-material/AltRoute';
import AppShortcut from '@mui/icons-material/AppShortcut';
import Archive from '@mui/icons-material/Archive';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import ArrowRight from '@mui/icons-material/ArrowRight';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import AssignmentInd from '@mui/icons-material/AssignmentInd';
import Attachment from '@mui/icons-material/Attachment';
import AutoAwesome from '@mui/icons-material/AutoAwesome';
import AutoMode from '@mui/icons-material/AutoMode';
import BackupTable from '@mui/icons-material/BackupTable';
import BadgeOutlined from '@mui/icons-material/BadgeOutlined';
import BalanceOutlined from '@mui/icons-material/BalanceOutlined';
import Block from '@mui/icons-material/Block';
import BrokenImageOutlined from '@mui/icons-material/BrokenImageOutlined';
import Business from '@mui/icons-material/Business';
import BusinessOutlined from '@mui/icons-material/BusinessOutlined';
import Cached from '@mui/icons-material/Cached';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import CalendarToday from '@mui/icons-material/CalendarToday';
import Campaign from '@mui/icons-material/Campaign';
import Cancel from '@mui/icons-material/Cancel';
import CancelOutlined from '@mui/icons-material/CancelOutlined';
import CancelRounded from '@mui/icons-material/CancelRounded';
import Chat from '@mui/icons-material/Chat';
import ChatBubbleOutline from '@mui/icons-material/ChatBubbleOutline';
import ChatOutlined from '@mui/icons-material/ChatOutlined';
import Check from '@mui/icons-material/Check';
import CheckCircle from '@mui/icons-material/CheckCircle';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import CheckCircleRounded from '@mui/icons-material/CheckCircleRounded';
import ChecklistOutlined from '@mui/icons-material/ChecklistOutlined';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Circle from '@mui/icons-material/Circle';
import Clear from '@mui/icons-material/Clear';
import Close from '@mui/icons-material/Close';
import CloseFullscreen from '@mui/icons-material/CloseFullscreen';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import CloudUpload from '@mui/icons-material/CloudUpload';
import ContactPhoneOutlined from '@mui/icons-material/ContactPhoneOutlined';
import ContentCopy from '@mui/icons-material/ContentCopy';
import ContentPasteOffOutlined from '@mui/icons-material/ContentPasteOffOutlined';
import Create from '@mui/icons-material/Create';
import CreateNewFolder from '@mui/icons-material/CreateNewFolder';
import DataObject from '@mui/icons-material/DataObject';
import DateRange from '@mui/icons-material/DateRange';
import Delete from '@mui/icons-material/Delete';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import DeleteOutlined from '@mui/icons-material/DeleteOutlined';
import Description from '@mui/icons-material/Description';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import DnsOutlined from '@mui/icons-material/DnsOutlined';
import DocumentScanner from '@mui/icons-material/DocumentScanner';
import DocumentScannerOutlined from '@mui/icons-material/DocumentScannerOutlined';
import DoDisturbAlt from '@mui/icons-material/DoDisturbAlt';
import DoneAll from '@mui/icons-material/DoneAll';
import DoNotDisturbAlt from '@mui/icons-material/DoNotDisturbAlt';
import Download from '@mui/icons-material/Download';
import Edit from '@mui/icons-material/Edit';
import EditOutlined from '@mui/icons-material/EditOutlined';
import EmailOutlined from '@mui/icons-material/EmailOutlined';
import Error from '@mui/icons-material/Error';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import Euro from '@mui/icons-material/Euro';
import EuroSymbol from '@mui/icons-material/EuroSymbol';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import FactCheck from '@mui/icons-material/FactCheck';
import FactCheckOutlined from '@mui/icons-material/FactCheckOutlined';
import FileCopy from '@mui/icons-material/FileCopy';
import FileCopyOutlined from '@mui/icons-material/FileCopyOutlined';
import FileOpen from '@mui/icons-material/FileOpen';
import FileOpenOutlined from '@mui/icons-material/FileOpenOutlined';
import FileUpload from '@mui/icons-material/FileUpload';
import Flip from '@mui/icons-material/Flip';
import FolderCopy from '@mui/icons-material/FolderCopy';
import FolderCopyOutlined from '@mui/icons-material/FolderCopyOutlined';
import FolderSpecial from '@mui/icons-material/FolderSpecial';
import FormatListBulleted from '@mui/icons-material/FormatListBulleted';
import FormatListNumbered from '@mui/icons-material/FormatListNumbered';
import ForumOutlined from '@mui/icons-material/ForumOutlined';
import Grading from '@mui/icons-material/Grading';
import Handshake from '@mui/icons-material/Handshake';
import Help from '@mui/icons-material/Help';
import HelpOutline from '@mui/icons-material/HelpOutline';
import History from '@mui/icons-material/History';
import Home from '@mui/icons-material/Home';
import HorizontalRule from '@mui/icons-material/HorizontalRule';
import HourglassEmpty from '@mui/icons-material/HourglassEmpty';
import HourglassTopOutlined from '@mui/icons-material/HourglassTopOutlined';
import Http from '@mui/icons-material/Http';
import IndeterminateCheckBoxOutlined from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import Info from '@mui/icons-material/Info';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import InsertDriveFile from '@mui/icons-material/InsertDriveFile';
import InsertDriveFileOutlined from '@mui/icons-material/InsertDriveFileOutlined';
import IosShare from '@mui/icons-material/IosShare';
import Keyboard from '@mui/icons-material/Keyboard';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import KeyboardDoubleArrowLeft from '@mui/icons-material/KeyboardDoubleArrowLeft';
import LocalShipping from '@mui/icons-material/LocalShipping';
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';
import LocalShippingRounded from '@mui/icons-material/LocalShippingRounded';
import LocationOff from '@mui/icons-material/LocationOff';
import LocationOn from '@mui/icons-material/LocationOn';
import Lock from '@mui/icons-material/Lock';
import LockOpenOutlined from '@mui/icons-material/LockOpenOutlined';
import LockOutlined from '@mui/icons-material/LockOutlined';
import Logout from '@mui/icons-material/Logout';
import LogoutOutlined from '@mui/icons-material/LogoutOutlined';
import Loop from '@mui/icons-material/Loop';
import MailOutline from '@mui/icons-material/MailOutline';
import MailOutlineOutlined from '@mui/icons-material/MailOutlineOutlined';
import MarkEmailRead from '@mui/icons-material/MarkEmailRead';
import MoreHoriz from '@mui/icons-material/MoreHoriz';
import MoreVert from '@mui/icons-material/MoreVert';
import NavigateBefore from '@mui/icons-material/NavigateBefore';
import NavigateNext from '@mui/icons-material/NavigateNext';
import NetworkCheck from '@mui/icons-material/NetworkCheck';
import OpenInFull from '@mui/icons-material/OpenInFull';
import OpenInNew from '@mui/icons-material/OpenInNew';
import PaymentsOutlined from '@mui/icons-material/PaymentsOutlined';
import PeopleAlt from '@mui/icons-material/PeopleAlt';
import PeopleOutline from '@mui/icons-material/PeopleOutline';
import Person from '@mui/icons-material/Person';
import PersonAdd from '@mui/icons-material/PersonAdd';
import PersonAddAltOutlined from '@mui/icons-material/PersonAddAltOutlined';
import PersonOutline from '@mui/icons-material/PersonOutline';
import PersonOutlined from '@mui/icons-material/PersonOutlined';
import Phone from '@mui/icons-material/Phone';
import PhoneAndroid from '@mui/icons-material/PhoneAndroid';
import PhoneOutlined from '@mui/icons-material/PhoneOutlined';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import PictureAsPdf from '@mui/icons-material/PictureAsPdf';
import Place from '@mui/icons-material/Place';
import PlayArrow from '@mui/icons-material/PlayArrow';
import PowerSettingsNew from '@mui/icons-material/PowerSettingsNew';
import PriorityHigh from '@mui/icons-material/PriorityHigh';
import QrCode2 from '@mui/icons-material/QrCode2';
import QuestionMark from '@mui/icons-material/QuestionMark';
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import Receipt from '@mui/icons-material/Receipt';
import ReceiptLong from '@mui/icons-material/ReceiptLong';
import Refresh from '@mui/icons-material/Refresh';
import Remove from '@mui/icons-material/Remove';
import RemoveDone from '@mui/icons-material/RemoveDone';
import RemoveRedEye from '@mui/icons-material/RemoveRedEye';
import RemoveRounded from '@mui/icons-material/RemoveRounded';
import Replay from '@mui/icons-material/Replay';
import Restore from '@mui/icons-material/Restore';
import RocketLaunchOutlined from '@mui/icons-material/RocketLaunchOutlined';
import RotateRight from '@mui/icons-material/RotateRight';
import RuleOutlined from '@mui/icons-material/RuleOutlined';
import Save from '@mui/icons-material/Save';
import Schedule from '@mui/icons-material/Schedule';
import Search from '@mui/icons-material/Search';
import SellOutlined from '@mui/icons-material/SellOutlined';
import Send from '@mui/icons-material/Send';
import SendRounded from '@mui/icons-material/SendRounded';
import Settings from '@mui/icons-material/Settings';
import SettingsSharp from '@mui/icons-material/SettingsSharp';
import Share from '@mui/icons-material/Share';
import Shield from '@mui/icons-material/Shield';
import SkipNext from '@mui/icons-material/SkipNext';
import StarBorderRounded from '@mui/icons-material/StarBorderRounded';
import StarRounded from '@mui/icons-material/StarRounded';
import StopCircleOutlined from '@mui/icons-material/StopCircleOutlined';
import Storage from '@mui/icons-material/Storage';
import StorefrontOutlined from '@mui/icons-material/StorefrontOutlined';
import SupportOutlined from '@mui/icons-material/SupportOutlined';
import Sync from '@mui/icons-material/Sync';
import TableChart from '@mui/icons-material/TableChart';
import TableChartOutlined from '@mui/icons-material/TableChartOutlined';
import TableRows from '@mui/icons-material/TableRows';
import ThumbUpRounded from '@mui/icons-material/ThumbUpRounded';
import TimerOffOutlined from '@mui/icons-material/TimerOffOutlined';
import TrendingDown from '@mui/icons-material/TrendingDown';
import TrendingUpOutlined from '@mui/icons-material/TrendingUpOutlined';
import Tune from '@mui/icons-material/Tune';
import Undo from '@mui/icons-material/Undo';
import UnfoldLess from '@mui/icons-material/UnfoldLess';
import UnfoldMore from '@mui/icons-material/UnfoldMore';
import Upload from '@mui/icons-material/Upload';
import VerifiedOutlined from '@mui/icons-material/VerifiedOutlined';
import VerifiedUser from '@mui/icons-material/VerifiedUser';
import VerifiedUserOutlined from '@mui/icons-material/VerifiedUserOutlined';
import Videocam from '@mui/icons-material/Videocam';
import ViewWeek from '@mui/icons-material/ViewWeek';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import WarehouseRounded from '@mui/icons-material/WarehouseRounded';
import Warning from '@mui/icons-material/Warning';
import WarningAmber from '@mui/icons-material/WarningAmber';
import WarningRounded from '@mui/icons-material/WarningRounded';
import WorkOutline from '@mui/icons-material/WorkOutline';
import YardOutlined from '@mui/icons-material/YardOutlined';
import ZoomIn from '@mui/icons-material/ZoomIn';
import ZoomOut from '@mui/icons-material/ZoomOut';
import ZoomOutMap from '@mui/icons-material/ZoomOutMap';

import { type IconGlyph } from '../types';

export const MUI_ICONS = {
  accessTime: AccessTime,
  accessTimeOutlined: AccessTimeOutlined,
  accountBalanceOutlined: AccountBalanceOutlined,
  accountCircle: AccountCircle,
  add: Add,
  addBoxOutlined: AddBoxOutlined,
  addCommentOutlined: AddCommentOutlined,
  addLocation: AddLocation,
  addLocationAlt: AddLocationAlt,
  addOutlined: AddOutlined,
  address: Place,
  addRounded: AddRounded,
  ai: AutoAwesome,
  aiExtraction: AppShortcut,
  announce: Campaign,
  archive: Archive,
  arrowBack: ArrowBack,
  arrowBackIos: ArrowBackIos,
  arrowDown: ArrowDownward,
  arrowDropUp: ArrowDropUp,
  arrowForward: ArrowForward,
  arrowForwardIos: ArrowForwardIos,
  arrowRight: ArrowRight,
  arrowUp: ArrowUpward,
  assign: AssignmentInd,
  attachment: Attachment,
  backupTable: BackupTable,
  badgeOutlined: BadgeOutlined,
  balanceOutlined: BalanceOutlined,
  block: Block,
  brokenImageOutlined: BrokenImageOutlined,
  businessOutlined: BusinessOutlined,
  cached: Cached,
  calendar: CalendarMonth,
  calendarToday: CalendarToday,
  cancel: Cancel,
  cancelOutlined: CancelOutlined,
  cancelRounded: CancelRounded,
  chatBubbleOutline: ChatBubbleOutline,
  chatOutlined: ChatOutlined,
  check: Check,
  checkCircle: CheckCircle,
  checkCircleOutline: CheckCircleOutline,
  checkCircleRounded: CheckCircleRounded,
  checklistOutlined: ChecklistOutlined,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  circle: Circle,
  clear: Clear,
  close: Close,
  closeOutlined: CloseOutlined,
  cloudUpload: CloudUpload,
  comment: Chat,
  company: Business,
  contactPhoneOutlined: ContactPhoneOutlined,
  contentPasteOffOutlined: ContentPasteOffOutlined,
  copy: ContentCopy,
  create: Create,
  createNewFolder: CreateNewFolder,
  dataExchange: Loop,
  dataObject: DataObject,
  dateRange: DateRange,
  delete: Delete,
  deleteOutline: DeleteOutline,
  deleteOutlined: DeleteOutlined,
  deliveryNote: ReceiptLong,
  deliveryNoteAssigned: Receipt,
  deliveryNoteSigned: Grading,
  description: Description,
  descriptionOutlined: DescriptionOutlined,
  dnsOutlined: DnsOutlined,
  documentScanner: DocumentScanner,
  documentScannerOutlined: DocumentScannerOutlined,
  doDisturbAlt: DoDisturbAlt,
  doneAll: DoneAll,
  download: Download,
  edit: Edit,
  editOutlined: EditOutlined,
  email: AlternateEmail,
  emailOutlined: EmailOutlined,
  endpoint: Http,
  error: Error,
  errorOutline: ErrorOutline,
  euro: Euro,
  euroSymbol: EuroSymbol,
  expand: ExpandMore,
  expandLess: ExpandLess,
  expandSmall: ArrowDropDown,
  factCheck: FactCheck,
  factCheckOutlined: FactCheckOutlined,
  failed: Clear,
  fileCopy: FileCopy,
  fileCopyOutlined: FileCopyOutlined,
  fileOpen: FileOpen,
  fileOpenOutlined: FileOpenOutlined,
  folderCopy: FolderCopy,
  folderCopyOutlined: FolderCopyOutlined,
  folderSpecial: FolderSpecial,
  forbidden: DoNotDisturbAlt,
  forumOutlined: ForumOutlined,
  fullscreenClose: CloseFullscreen,
  fullscreenOpen: OpenInFull,
  handshake: Handshake,
  help: Help,
  helpOutlined: HelpOutline,
  history: History,
  home: Home,
  horizontalLine: HorizontalRule,
  hourglassTopOutlined: HourglassTopOutlined,
  indeterminateCheckBoxOutlined: IndeterminateCheckBoxOutlined,
  info: Info,
  infoOutlined: InfoOutlined,
  insertDriveFile: InsertDriveFile,
  insertDriveFileOutlined: InsertDriveFileOutlined,
  iosShare: IosShare,
  keyboard: Keyboard,
  keyboardArrowDown: KeyboardArrowDown,
  keyboardArrowLeft: KeyboardArrowLeft,
  keyboardArrowRight: KeyboardArrowRight,
  keyboardDoubleArrowLeft: KeyboardDoubleArrowLeft,
  list: FormatListBulleted,
  listNumbered: FormatListNumbered,
  localShipping: LocalShipping,
  localShippingOutlined: LocalShippingOutlined,
  localShippingRounded: LocalShippingRounded,
  locationOff: LocationOff,
  locationOn: LocationOn,
  lock: Lock,
  lockOpenOutlined: LockOpenOutlined,
  lockOutlined: LockOutlined,
  logout: Logout,
  logoutOutlined: LogoutOutlined,
  mailOutline: MailOutline,
  mailOutlineOutlined: MailOutlineOutlined,
  markEmailRead: MarkEmailRead,
  more: MoreHoriz,
  moreVert: MoreVert,
  navigateBefore: NavigateBefore,
  navigateNext: NavigateNext,
  networkCheck: NetworkCheck,
  ocr: Flip,
  off: PowerSettingsNew,
  on: PowerSettingsNew,
  openInNew: OpenInNew,
  paymentsOutlined: PaymentsOutlined,
  peopleAlt: PeopleAlt,
  person: Person,
  personAdd: PersonAddAltOutlined,
  personAddFilled: PersonAdd,
  personOutline: PersonOutline,
  personOutlined: PersonOutlined,
  phone: Phone,
  phoneAndroid: PhoneAndroid,
  phoneOutlined: PhoneOutlined,
  photoCamera: PhotoCamera,
  pictureAsPdf: PictureAsPdf,
  playArrow: PlayArrow,
  priorityHigh: PriorityHigh,
  processWithAI: AutoMode,
  qrCode: QrCode2,
  questionMark: QuestionMark,
  radioButtonUnchecked: RadioButtonUnchecked,
  refresh: Refresh,
  remove: Remove,
  removeDone: RemoveDone,
  removeRedEye: RemoveRedEye,
  removeRounded: RemoveRounded,
  replay: Replay,
  restore: Restore,
  rocketLaunchOutlined: RocketLaunchOutlined,
  rotateRight: RotateRight,
  route: AltRoute,
  ruleOutlined: RuleOutlined,
  save: Save,
  schedule: Schedule,
  search: Search,
  sellOutlined: SellOutlined,
  send: Send,
  sendRounded: SendRounded,
  settings: Settings,
  settingsSharp: SettingsSharp,
  share: Share,
  shield: Shield,
  skipNext: SkipNext,
  starBorderRounded: StarBorderRounded,
  starRounded: StarRounded,
  stopCircleOutlined: StopCircleOutlined,
  storage: Storage,
  storefrontOutlined: StorefrontOutlined,
  supportOutlined: SupportOutlined,
  sync: Sync,
  table: TableChart,
  tableChartOutlined: TableChartOutlined,
  tableRows: TableRows,
  thumbUpRounded: ThumbUpRounded,
  timerOffOutlined: TimerOffOutlined,
  trendDown: TrendingDown,
  trendUp: TrendingUpOutlined,
  tune: Tune,
  undo: Undo,
  unfoldLess: UnfoldLess,
  unfoldMore: UnfoldMore,
  upload: Upload,
  uploadFile: FileUpload,
  user: Person,
  users: PeopleOutline,
  usersActive: AccountBoxOutlined,
  verifiedOutlined: VerifiedOutlined,
  verifiedUser: VerifiedUser,
  verifiedUserOutlined: VerifiedUserOutlined,
  videocam: Videocam,
  viewWeek: ViewWeek,
  visibility: Visibility,
  visibilityOff: VisibilityOff,
  waiting: HourglassEmpty,
  warehouseRounded: WarehouseRounded,
  warningAmber: WarningAmber,
  warningFilled: Warning,
  warningRounded: WarningRounded,
  warningSlim: PriorityHigh,
  workOutline: WorkOutline,
  yardOutlined: YardOutlined,
  zoomFit: ZoomOutMap,
  zoomIn: ZoomIn,
  zoomOut: ZoomOut,
} as const satisfies Record<string, IconGlyph>;
